module.exports = __webpack_public_path__ + "static/media/skkick.2a49a46a.wav";